<template>
  <StyledModal :visible="visible" :title="`新建银行卡`" @close="close" @submit="submit" :submitLoading="submitLoading">
    <el-form class="form_box" ref="formRef" :model="formModel.form" label-width="120px">
      <el-form-item label="选择医生" prop="doctorCode" :rules="[{ required: true, message: '请选择医生' }]">
        <FetchSelect
          v-model="formModel.form.doctorCode"
          :postData="{ page: 1, rows: 100000 }"
          api="/web/system/doctorncp/getDoctorList"
          valueKey="doctorCode"
          textKey="doctorName"
        />
      </el-form-item>
      <el-form-item label="持卡人姓名" prop="custName" :rules="[{ required: true, message: '请选择医生' }]">
        <el-input v-model="formModel.form.custName" placeholder="请输入持卡人姓名"></el-input>
      </el-form-item>
      <el-form-item label="银行选择" prop="bankCode" :rules="[{ required: true, message: '请选择银行' }]">
        <FetchSelect v-model="formModel.form.bankCode" api="/web/sys/bank/getBankDropDown" textKey="bankName" valueKey="bankCode" />
      </el-form-item>
      <el-form-item label="银行卡号" prop="cardNo" :rules="[{ required: true, message: '请输入银行卡号' }]">
        <el-input v-model="formModel.form.cardNo" placeholder="银行卡号"></el-input>
      </el-form-item>
      <el-form-item label="预留手机号" prop="phoneNumber" :rules="[{ required: true, message: '请输入银行卡号' }]">
        <el-input length="11" v-model="formModel.form.phoneNumber" placeholder="预留手机号"></el-input>
      </el-form-item>
      <el-form-item label="银行卡照片" prop="cardImage" :rules="[{ required: false, message: '请上传银行卡照片' }]">
        <ImgUpload v-model="formModel.form.cardImage" :limit="1" />
      </el-form-item>
      <el-form-item
        label="卡排序"
        prop="cardOrder"
        :rules="[
          { required: true, message: '请输入卡排序' },
          { type: 'number', min: 0, max: 99999, message: '请输入0-99999之间的数字' },
        ]"
      >
        <el-input v-model.number="formModel.form.cardOrder" placeholder="0-99999之间"></el-input>
      </el-form-item>
      <el-form-item label="是否默认" prop="ifDefault" :rules="[{ required: true }]">
        <el-radio-group v-model="formModel.form.ifDefault">
          <el-radio label="1">是</el-radio>
          <el-radio label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="formModel.form.remark" placeholder="请输入" type="textarea"></el-input>
      </el-form-item>
    </el-form>
  </StyledModal>
</template>

<script>
import { reactive, ref, computed } from 'vue'
import { cloneDeep } from 'lodash'
import StyledModal from '@/components/modal/StyledModal'
import ImgUpload from '@/components/ImgUpload'
import FetchSelect from '@/components/FetchSelect/index.vue'
import { validateFormRef } from '@/common/utils_element'
import request from '@/utils/request'

const defaultForm = {
  departName: '',
  departLogo: '',
  departClassCode: '',
  departDesc: '',
  departSeq: '',
  ifShowIndex: '0',
}

export default {
  emits: ['successAdd', 'successEdit'],
  setup(_, ctx) {
    const visible = ref(false)
    const submitLoading = ref(false)

    const formRef = ref(null)
    const formModel = reactive({
      form: cloneDeep(defaultForm),
    })

    const record = reactive({ v: null })
    const isAdd = computed(() => (record.v ? false : true))

    function open(recordParam) {
      visible.value = true
      if (recordParam) {
        record.v = cloneDeep(recordParam)
        renderForm(cloneDeep(recordParam))
      }
    }

    function close() {
      visible.value = false
      record.v = null
      formModel.form = cloneDeep(defaultForm)
    }

    // form回显
    function renderForm(data) {
      formModel.form = {
        ...data,
        ifShowIndex: data.ifShowIndex ?? defaultForm.ifShowIndex,
      }
    }

    // 提交
    async function submit() {
      await validateFormRef(formRef)
      submitLoading.value = true
      request({
        url: '/web/system/bankcard/addBankCard',
        data: {
          ...formModel.form,
        },
      })
        .finally(() => {
          submitLoading.value = false
        })
        .then(() => {
          ctx.emit(isAdd.value ? 'successAdd' : 'successEdit')
          close()
        })
    }

    return {
      visible,
      isAdd,
      submitLoading,
      open,
      close,
      submit,
      //
      formRef,
      formModel,
    }
  },
  components: { StyledModal, FetchSelect, ImgUpload },
}
</script>

<style lang="less" scoped>
.form_box {
  width: 90%;
}
</style>
